export default __webpack_public_path__ + "static/media/intp@3x.8017bdc0.png";